import { STORAGE_USER } from 'constant/app';
import {
  ROLE_DASH_ADMIN,
  ROLE_DASH_ADMINISTRATOR,
  ROLE_DASH_AGENT,
} from 'constant/authority';
import { UserResponse } from 'types';
import { StorageUtils } from 'utils';

function getResolvedUser(user?: UserResponse) {
  return user ?? StorageUtils.getObject(STORAGE_USER);
}

function getResolvedAuthorities(user?: UserResponse) {
  return getResolvedUser(user)?.profile?.authorities ?? [];
}

export function hasAuthority(authority: string, user?: UserResponse) {
  return getResolvedAuthorities(user).some((el: string) => el === authority);
}

export function hasAnyAuthority(authority: string[], user?: UserResponse) {
  return getResolvedAuthorities(user).some((el: string) => authority.includes(el));
}

export function getDashboardVariant(
  user?: UserResponse,
): 'ADMIN' | 'ADMINISTRATOR' | 'AGENT' | undefined {
  const resolvedUser = getResolvedUser(user);

  if (hasAuthority(ROLE_DASH_ADMIN, resolvedUser)) {
    return 'ADMIN';
  }

  if (hasAuthority(ROLE_DASH_ADMINISTRATOR, resolvedUser)) {
    return 'ADMINISTRATOR';
  }

  if (hasAuthority(ROLE_DASH_AGENT, resolvedUser)) {
    return 'AGENT';
  }
}

export function isAgentDashboardUser(user?: UserResponse) {
  return getDashboardVariant(user) === 'AGENT';
}

export function getInitials(fullName: string) {
  const splitted = fullName.split(' ');
  return (splitted[0].charAt(0) + splitted[1].charAt(0)).toUpperCase();
}
